// extracted by mini-css-extract-plugin
module.exports = {"SignUp":"NewsletterInput_SignUp__7xUAY","NewsletterSuccess":"NewsletterInput_NewsletterSuccess__5ZcQ4"};